import type { CalculatorMeta } from '../../types/calculator';

const meta: CalculatorMeta = {
  route: '/equipment-lease-vs-buy',
  component: () => import('../../routes/LeaseVsBuyEquipment.svelte'),
  card: {
    id: 'lease-vs-buy-equipment',
    title: 'Equipment Lease vs Buy Calculator',
    description: 'Compare the total cost of buying equipment versus leasing. Uses NPV analysis and Equivalent Annual Cost (EAC) to determine the most cost-effective option.',
    icon: 'swap_horiz',
    iconBgClass: 'bg-blue-50',
    iconTextClass: 'text-blue-600',
    href: '/equipment-lease-vs-buy',
    category: 'Business',
  },
  seo: {
    title: 'Equipment Lease vs Buy Calculator – NPV & Equivalent Annual Cost Analysis',
    description: 'Free equipment lease vs buy calculator for businesses. Compare buying versus leasing equipment using NPV analysis, Equivalent Annual Cost (EAC), and depreciation tax shields. Supports straight-line and double-declining depreciation.',
  },
};

export default meta;
